export interface ActiveUserInfo {
  id: number;
  email: string;
  full_name?: string;
  username?: string;
  is_guest: boolean;
  iat: number;
  exp: number;
}

export interface ActiveAdminInfo {
  id: string;
  userName: string;
  role: string;
}
